import { render, staticRenderFns } from "./TableFocalPoints.vue?vue&type=template&id=58e6edac&"
import script from "./TableFocalPoints.vue?vue&type=script&lang=js&"
export * from "./TableFocalPoints.vue?vue&type=script&lang=js&"
import style0 from "./TableFocalPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports